export default __webpack_public_path__ + "static/media/Dashboard_icon.eab5c6c5.svg";